import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import {
   CreateCommentResponse,
   createComment as createCommentFromMonolith,
} from '~/monolith-api/guides';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

const createCommentSchema = z.object({
   context: z.string(),
   contextid: z.number(),
   text: z.string(),
   parentid: z.number().optional(),
   media: z
      .array(
         z.object({
            mediatype: z.enum(['GuideVideoObject', 'GuideImage']),
            mediaid: z.number(),
         })
      )
      .optional(),
});

export type CreateCommentOptions = z.infer<typeof createCommentSchema>;

export async function createComment(
   options: CreateCommentOptions,
   common: CommonRequestOptions = {}
) {
   return await createCommentFromMonolith(
      options.context,
      options.contextid,
      options.text,
      options.parentid,
      options.media,
      { ...common }
   );
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { context, contextid, text, parentid } = createCommentSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await createComment(
         { context, contextid, text, parentid },
         { apiClient: monolithClient }
      );
      res.status(200).json(result);
   },
});

export const createCommentFromClient = async (
   options: CreateCommentOptions
): Promise<CreateCommentResponse> => {
   return bff()
      .post('/guides/createComment', { options })
      .then(response => response.data);
};
